import { Theme } from "@emotion/react";
import { Autocomplete, SxProps, TextField } from "@mui/material";
import { trackerApi } from "../../../core/api/TrackerApi";
import { useQueryArray } from "../../../core/components/helpers/queryHelper";
import { CheckSubTypeDto } from "../CheckDataType";

const fetchCheckSubType = async (typeId?: number) => {

    let data: Array<CheckSubTypeDto> = await trackerApi.callServiceGet("/oot/check-type/sub-type/" + (typeId ?? 0))

    return data;
}

export const useQueryCheckSubTypeAutocomplete = (checkTypeId?: number) => {

    let query = useQueryArray<CheckSubTypeDto>(["oot/check-type/sub-type"], () => fetchCheckSubType(checkTypeId), "Oot Check SubType")

    return query;
}

interface CheckSubTypeAutocompleteProps {
    sx?: SxProps<Theme>
    label?: string
    checkTypeId?: number
    additionalOnChange?: (value: CheckSubTypeDto | null) => void,
    selection?: CheckSubTypeDto | null
}


export const CheckSubTypeQueryAutocomplete = (params: CheckSubTypeAutocompleteProps) => {

    let { data } = useQueryCheckSubTypeAutocomplete(params.checkTypeId);


    return <BaseCheckSubTypeAutocomplete {...params} data={data} />
}



interface BaseCheckSubTypeAutocompleteProps {
    data: Array<CheckSubTypeDto>
    label?: string,
    additionalOnChange?: (value: CheckSubTypeDto | null) => void,
    selection?: CheckSubTypeDto | null
    sx?: SxProps<Theme>
}

export const BaseCheckSubTypeAutocomplete = (params: BaseCheckSubTypeAutocompleteProps) => {

    let { data } = params;

    return <Autocomplete
        options={data}
        renderInput={(props) => <TextField {...props} label={params.label} multiline sx={{ textAlign: "center" }} />}
        getOptionLabel={(o) => o.name}
        filterOptions={(o, v) => o.filter(x => x.name.toLowerCase().includes(v.inputValue.toLowerCase()))}
        fullWidth
        sx={{ ...params.sx }}
        size='small'
        onChange={(e, v) => { params.additionalOnChange?.(v) }}
        value={params.selection}
        isOptionEqualToValue={option => option.id === params.selection?.id}
    />
}